import Vue     from 'vue'
import Router  from 'vue-router'
import Login   from '@/pages/login'
import Index   from "@/pages/index"

//运维管理平台
const OPERATION = [
  { path: 'Worktable',  name: 'Worktable',     tag:"平台概况-平台概况",    component:()=> import('@/pages/module-oper/module-index/index.vue')},
  { path: 'Platform',   name: 'Platform',      tag:"模块管理-模块列表",    component:()=> import('@/pages/module-oper/module-platform/index.vue')},
  { path: 'StationType',name: 'StationType',   tag:"工厂管理-工厂类型",    component:()=> import('@/pages/module-user/station/stationType.vue')},
  { path: 'System',     name: 'System',        tag:"系统管理-系统设置",    component:()=> import('@/pages/module-oper/system/system.vue')},
  { path: 'Setmeal',    name: 'Setmeal',       tag:"系统管理-充值套餐",    component:()=> import('@/pages/module-oper/system/setmeal.vue')},
  { path: 'Dictionar',  name: 'Dictionar',     tag:"字典管理-字典列表",    component:()=> import('@/pages/module-oper/module-dictionar/index.vue')},
  { path: 'Interface',  name: 'Interface',     tag:"接口文档-接口文档",    component:()=> import('@/pages/module-oper/module-interface/index.vue')},
  { path: 'Monitor',    name: 'Monitor',       tag:"产品管理-产品监控",    component:()=> import('@/pages/module-oper/module-product/product-monitor/index.vue')},
  { path: 'Message',    name: 'Message',       tag:"产品管理-产品信息",    component:()=> import('@/pages/module-oper/module-product/index-message.vue')},
  { path: 'EnMessage',  name: 'EnMessage',     tag:"产品管理-企业的产品",  component:()=> import('@/pages/module-oper/module-product/message/enMessageList.vue')},
  { path: 'FacilityNo', name: 'FacilityNo',    tag:"产品管理-待安装产品",  component:()=> import('@/pages/module-oper/module-product/index-installedNot.vue')},
  { path: 'Facility',   name: 'Facility',      tag:"产品管理-已安装产品",  component:()=> import('@/pages/module-oper/module-product/index-installed.vue')},
  { path: 'ImeiList',   name: 'ImeiList',      tag:"产品管理-IEME列表",       component:()=> import('@/pages/module-oper/module-product/message/Imeilist.vue')},
  { path: 'Alarmset',   name: 'Alarmset',      tag:"报警管理-报警设置",       component:()=> import('@/pages/module-oper/module-alarment/alarm-set/index.vue')},
  { path: 'Alarmlist',  name: 'Alarmlist',     tag:"报警管理-报警设置",       component:()=> import('@/pages/module-oper/module-alarment/alarm-list.vue')},
  { path: 'Templtype',  name: 'Templtype',     tag:"报警管理-报警模版",       component:()=> import('@/pages/module-oper/module-alarment/templ-type.vue')},
  { path: 'Alarmtype',  name: 'Alarmtype',     tag:"报警管理-报警类型",       component:()=> import('@/pages/module-oper/module-alarment/alarm-type.vue')},
  { path: 'Banner',     name: 'Banner',        tag:"banner管理- banner管理", component:()=> import('@/pages/module-oper/module-banner/index.vue')},
  { path: 'Project',    name:'Project',        tag:"项目管理-项目列表",       component:() => import('@/pages/module-oper/module-project/index.vue')},
  { path: 'profitp',    name:'profitp',        tag:"项目管理-分润项目",       component:() => import('@/pages/module-oper/module-profitp/index.vue')},
  { path: 'profitpList',    name:'profitpList',        tag:"项目管理-分润记录",       component:() => import('@/pages/module-oper/module-profitp/profitpList.vue')},
  { path: 'Financial',          name:'Financial',      tag:"财务管理-财务概况",       component:() => import('@/pages/module-oper/module-financial/financial/index.vue')},
  { path: 'Accounts',           name:'Accounts',       tag:"财务管理-财务台账",       component:() => import('@/pages/module-oper/module-financial/accounts/index.vue')},
  { path: 'Recharge',           name:'Recharge',       tag:"财务管理-账户充值管理",   component:() => import('@/pages/module-oper/module-financial/recharge/index.vue')},
  { path: 'RechargeDetail',     name:'RechargeDetail', tag:"财务管理-账户充值详情",   component:() => import('@/pages/module-oper/module-financial/rechargeDetails/index.vue')},
  { path: 'Servicelist',        name:'Servicelist',    tag:"财务管理-服务费充值记录", component:() => import('@/pages/module-oper/module-financial/service-list/index.vue')},
  { path: 'Shortsmlist',        name:'Shortsmlist',    tag:"财务管理-短信充值记录",   component:() => import('@/pages/module-oper/module-financial/shortsm-list/index.vue')},
  { path: 'Voicelist',          name:'Voicelist',      tag:"财务管理-语音充值记录",   component:() => import('@/pages/module-oper/module-financial/voice-list/index.vue')},
  { path: 'Walletlist',         name:'Walletlist',     tag:"财务管理-语音充值记录",   component:() => import('@/pages/module-oper/module-financial/wallet-list/index.vue')},
  { path: 'Operatelog',         name:'Operatelog',     tag:'日志管理-操作日志',  component: () => import ('@/pages/module-oper/module-log/operate-log/index.vue') },
  { path: 'AppLog',             name:'AppLog',         tag:'日志管理-APP日志',  component: () => import ('@/pages/module-oper/module-log/app-log/index.vue') },  
  { path: 'Announcentent',      name:'Announcentent',  tag:'公告管理-公告管理',  component: () => import ('@/pages/module-oper/module-announcement/index.vue') },   
  { path: 'FeedbackList',       name:'FeedbackList',      tag:'意见反馈-常见问题1', component: () => import ('@/pages/module-oper/module-feedback/feedback-list/index.vue') },
  { path: 'Feedbackundealwith', name:'Feedbackundealwith',tag:'意见反馈-待处理',   component: () => import ('@/pages/module-oper/module-feedback/feedback-undealwith/index.vue') },
  { path: 'Feedbackdealwith',   name:'Feedbackdealwith',  tag:'意见反馈-已处理',   component: () => import ('@/pages/module-oper/module-feedback/feedback-dealwith/index.vue') },
  { path: 'AppList',            name:'AppList',           tag:'APP-版本管理',      component: () => import ('@/pages/module-oper/module-app/app-list/index.vue') }


]

//用户管理平台 
const USERGROUP = [
    { path: 'IndexUser',   name: 'IndexUser',   tag:"用户管理-内部用户",   component:()=> import('@/pages/module-user/userzh/user-self.vue')},
    { path: 'AgentUser',   name: 'AgentUser',   tag:"用户管理-代理商用户", component:()=> import("@/pages/module-user/userzh/user-agent.vue")},
    { path: 'FactoryUser', name: 'FactoryUser', tag:"用户管理-工厂用户",   component:()=> import('@/pages/module-user/userzh/user-factory.vue')},
    { path: 'CompanyUser', name: 'CompanyUser', tag:"用户管理-工程商用户", component:()=> import('@/pages/module-user/userzh/user-company.vue')},
    { path: 'Terminal',    name: 'Terminal',    tag:"用户管理-个人用户",   component:()=> import('@/pages/module-user/userzh/user-terminal.vue')},
    { path: 'StationList', name: 'StationList', tag:"工厂管理--工厂列表",  component:()=> import('@/pages/module-user/station/stationList.vue')  },
    { path: 'RouleList',   name: 'RouleList',   tag:"角色管理-角色列表",   component:()=> import('@/pages/module-user/rolelist/rouleList.vue')},
    { path: 'Branch',      name: 'Branch',      tag:"部门管理-部门数据",   component:()=> import('@/pages/module-user/branch/branch.vue') },
   
]

//IOT管理平台
const IOTGROUP = [
  { path: 'Equipment',      name: 'Equipment',     tag:"设备分类--设备列表", component:()=> import('@/pages/module-Iotre/equipment/equipment.vue')},
  { path: 'EquipmentIcon',  name: 'EquipmentIcon', tag:"设备日志--日志列表", component:()=> import('@/pages/module-Iotre/equipmentIcon/index.vue')},
  { path: 'Protocol',       name: 'Protocol',      tag:"协议管理--私有协议", component:()=> import('@/pages/module-Iotre/protocol/protocol.vue')},
  { path: 'Devicelog',      name: 'Devicelog',     tag:"设备日志--日志列表", component:()=> import('@/pages/module-Iotre/devicelog/index.vue')},
  { path: 'Chargelog',      name: 'Chargelog',     tag:"设备日志--充电桩日志", component:()=> import('@/pages/module-Iotre/devicelog/chargelog/index.vue')},
  { path: 'Instruction',    name: 'Instruction',   tag:"设备指令--设各指今", component:()=> import('@/pages/module-Iotre/instruct/index.vue')}, 
  { path: 'DevManagement', name: 'DevManagement', tag:'设备管理--设备管理', component:()=> import('@/pages/module-Iotre/devmanagement/index.vue') }
]

//充电桩平台
const ELECTROUP = [
  { path: 'ElectUser',   name: 'ElectUser',   tag:'用户管理-充电桩管理', component:()=> import('@/pages/module-elect/elect-user/index.vue') },
  { path: 'ElectMark',   name: 'ElectMark',   tag:'标签管理-充电桩管理', component:()=> import('@/pages/module-elect/elect-mark/index.vue') }
]

Vue.use(Router)


//防止连续多次点击路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}

const router =  new Router({
  // mode: 'history',
  routes: [
      { 
        path: '/',
        name: 'Login', 
        component: Login
      },
      { 
        path: '/Index',
        name: 'Index',
        component: Index,
        redirect:'/Index/',
        children:[
        ...OPERATION,
        ...USERGROUP,
        ...IOTGROUP,
        ...ELECTROUP
       ]
      }
   ]
})



// 前置守卫
router.beforeEach((to,from,next)=>{
  let isPathBoolean = false;
  
  for(let i = 0;i<router.options.routes.length; i++){
    let item = router.options.routes[i];
    if(to.name != null && to.name == item.name){
      isPathBoolean = true;
      break;
    }else{
      isPathBoolean = isPathExist(to,item);
      if(isPathBoolean)break;
    }
    
  }

  if(isPathBoolean){
    next();
  }else{
    router.push({
      name:'Platform'
    })
  }
})

function isPathExist(to,item){
  if(!item.children)return false;
  let isFun = false;
  for(let i = 0;i<item.children.length; i++){
    let childeItem = item.children[i]
    if(to.name == childeItem.name){
      return true;
    }else{
      isFun =  isPathExist(to,childeItem)
    }
  }
  return isFun;

}

export default router